<template>
  <div class="operation-record">
    <div
      class="record-item"
      v-for="(record, index) in data"
      :key="index"
    >
      <div class="record-header">
        <icon-font name="icon-time" class="time-icon" />
        <span class="action-type">{{ record.title }}</span>
      </div>
      <div class="record-user">
        <icon-font name="icon-user" class="user-icon" />
        <span class="action-type">{{ record.operator }}</span>
        <span class="record-time">{{ record.date }}</span>
      </div>
      <div class="record-content" v-if="record.content">
        <div
          class="content-item"
        >
          <span class="field-value" style="white-space: pre-line">{{ toText(record.content) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'xwFlow',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // 日志文字含用户输入，只认服务端拼的换行标签（含历史写法 </br>、<bn>），其余按纯文本显示，不能用 v-html
    toText(str) {
      return this.decodeHtmlEntities(str).replace(/\r?\n/g, ' ').replace(/<\/?b[rn]\s*\/?>/gi, '\n')
    },
    decodeHtmlEntities(str) {
      if (!str) return ''
      const textarea = document.createElement('textarea')
      // 处理多重转义的情况，循环解码直到字符串不再变化
      let decoded = str
      let prevDecoded = ''
      while (decoded !== prevDecoded) {
        prevDecoded = decoded
        textarea.innerHTML = decoded
        decoded = textarea.value
      }
      return decoded
    },
  },
}
</script>
<style scoped lang="less">
.operation-record {
  .record-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .record-header {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 10px;
    .time-icon {
      color: #1456f0;
      margin-right: 5px;
    }
    .action-type {
      font-size: 12px;
      color: #2e343d;
      margin-right: auto;
    }
  }
  .record-user {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 10px;
    .user-icon {
      margin-right: 5px;
    }
    .action-type {
      font-size: 12px;
      color: #7e8288;
      margin-right: auto;
    }
    .record-time {
      font-size: 12px;
      color: #999;
    }
  }
  .record-content {
    background: #f5f6f7;
    padding: 8px;
    border-radius: 4px;
    .content-item {
      margin-bottom: 8px;
      font-size: 12px;
      color: #2E343D;
      &:last-child {
        margin-bottom: 0;
      }
      .field-name {
        margin-right: 6px;
      }
    }
  }
}
</style>
